module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_c('a', {
    attrs: {
      "id": "a24"
    }
  }), _vm._v("Chapter 2")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Spenser Hudson stood next to the stove, stirring the simmering marinara sauce. Henrietta, a miniature schnauzer, sat at his feet. She impatiently shifted from one foot to another and whined.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Daddy Jordan’ll be mad at me if I give you anything,” Spenser said, smiling down at the little dog. “The vet told him you have to take off some weight. Daddy said I’m making you fat because I can’t resist you. Well, he’s right. You’re so gosh darn cute.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Spenser bent and took the pup’s face in his hands and gave her a kiss on the nose. He straightened up and turned back to stirring the sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Henrietta whined again, then gave a sharp, demanding yip.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Spenser grimaced, then smiled. He pulled a strand of spaghetti from a colander on the counter with a fork. “Okay, but if Jordan finds out and I get in trouble…”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("He held the treat up over the little dog’s head. “Sit up!” he said. Henrietta sat up on her haunches and waved her paws.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Spenser dropped the spaghetti. Henrietta caught it.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Good girl,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Anybody home?” Jordan sang out from the living room.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Spenser jumped. “Crap!”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Henrietta barked and ran for the door.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Remember. Don’t tell,” Spenser called softly after her as he followed her out of the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Spenser smiled, trying to not look guilty as he entered the living room. Jordan was on his knees, Henrietta in his arms, wiggling and whining her greeting as she licked his nose. Jordan smiled when he saw Spenser, put the happy pooch down, and rose to his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("The two men walked to each other, embraced, and kissed.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“My, don’t you smell all fresh and clean—like you just had a shower,” Spenser said.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Yep, I did. Stopped at the gym after work.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Was it hard at the office again today?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“You could say that.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Your boss still giving you a tough time?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Not really. I just needed some exercise after sitting behind a desk and staring at a computer screen all day. Besides, I want to keep in shape for ma man.” He kissed Spenser again.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Spenser leaned into the kiss and ran his hands over Jordan’s muscular frame. “And I appreciate it.” He pressed his hardening cock against Jordan and added, “As you can tell.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Jordan chuckled, reached down, and rubbed Spenser’s package.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Spenser sighed.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“But can we wait awhile before I get to enjoy your appreciation?” Jordan asked. “I’m starving. Something smells real good. Dinner ready?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Spenser pressed his hard package into Jordan’s hand and gave him another peck. “Well, okay, but promise I get to show you just how much appreciation I have later. Last night you dozed off before I got to bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Jordan raised his right hand. “I promise. Now, what’s for supper? Smells like my favorite—my mom’s Italian spaghetti.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Spenser gave Jordan another kiss before he stepped back and headed for the kitchen. “Sorry, it’s just Ragu and salad. I didn’t have time to make your mother’s sauce from scratch. But I did brown some hamburger to pump it up a bit. Teachers’ meeting ran late. Sue Washburn had her usual list of complaints. At times I wish I’d never accepted the principal job.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Jordan and Henrietta followed Spenser out of the living room and into the kitchen. “I’m not gonna complain about your cooking. I can’t boil water. All you get is Domino’s pizza, KFC, or some other crappy fast food when it’s my turn to make dinner. And don’t sell yourself short. You’re doing a great job as principal.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Thanks for the vote of confidence. But sometimes I just feel overwhelmed, like they picked me cuz I was the easy choice. I’m not really qualified on paper.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Spenser went to the stove to dish up the meal. “By the way, I didn’t fall in love with you because of your culinary skills.” He turned to the table with two plates of steaming spaghetti. “I fell for a handsome man of impeccable character, who’s made all my dreams come true.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Jordan gave Spenser a wistful smile. They sat down and joined hands. Spenser said grace.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14ee12a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006.vue
// module id = 69
// module chunks = 0